import { ROUTES } from 'src/enums';

export default [
  {
    path: '/books',
    meta: {
      auth: true,
    },
    component: () => import('layouts/SpaLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('layouts/BooksLayout.vue'),
        children: [
          {
            path: '',
            name: ROUTES.BOOKS.INDEX,
            component: () => import('pages/books/PageBookGenerator.vue'),
          },
          {
            path: 'brand-voice',
            name: ROUTES.BOOKS.BRAND_VOICE,
            component: () => import('pages/BrandVoicePage.vue'),
          },
          {
            path: 'email-chains',
            name: ROUTES.BOOKS.EMAIL_CHAINS,
            component: () => import('pages/EmailChainsPage.vue'),
          },
          {
            path: 'autoresponder',
            name: ROUTES.BOOKS.AUTORESPONDER,
            component: () => import('pages/AutoresponderPage.vue'),
          },
          {
            path: 'domains',
            name: ROUTES.BOOKS.DOMAINS,
            props: { isBooks: true },
            component: () => import('pages/DomainsPage.vue'),
          },
          {
            path: 'leads',
            name: ROUTES.BOOKS.LEADS,
            component: () => import('pages/LeadsBooksPage.vue'),
          },
          {
            path: 'payment-providers',
            name: ROUTES.BOOKS.PAYMENT_PROVIDERS,
            component: () => import('pages/PaymentProviders.vue'),
          },
        ],
      },
      {
        path: '',
        component: () => import('layouts/BooksEditorLayout.vue'),
        children: [
          {
            path: 'wizard/:bookGuid?',
            name: ROUTES.BOOKS.WIZARD,
            props: true,
            component: () => import('pages/books/BookGeneratorWizard.vue'),
          },
          {
            path: 'editor/:bookGuid',
            props: true,
            name: ROUTES.BOOKS.EDITOR,
            meta: { auth: true },
            component: () => import('pages/books/BookEditorPage.vue'),
            children: [
              {
                path: 'settings',
                meta: { auth: true },
                name: ROUTES.BOOKS.SETTINGS,
                component: () => import('components/book/BookPageSettings.vue'),
              },
            ],
          },
          {
            path: ':pageBookGuid/landing-page',
            name: ROUTES.BOOKS.LANDING,
            props: true,
            component: () => import('pages/books/BookLandingPageSettings.vue'),
          },
          {
            path: ':pageBookGuid/thankyou-page',
            name: ROUTES.BOOKS.THANKYOU,
            props: true,
            component: () => import('pages/books/BookThankYouPageSettings.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/book/:bookSlug/page/:bookPageSlug',
    name: ROUTES.BOOKS.PAGE_RENDER,
    meta: { skipRedirect: true },
    component: () => import('pages/books/render/RenderBookPage.vue'),
  },
  {
    path: '/book/:bookSlug/:accessHash?',
    name: ROUTES.BOOKS.PREVIEW,
    meta: { auth: true, skipRedirect: true },
    component: () => import('pages/preview/PreviewPage.vue'),
  },
  {
    path: '/book/not_found',
    name: ROUTES.BOOKS.NOT_FOUND,
    component: () => import('pages/BookLandingNotFoundPage.vue'),
  },
];
